<template>
  <div class="pie-box">
    <div class="pie-flx">
      <template v-if="piedata.length">
        <Vchart :option="echartData" />
      </template>
      <template v-else>
        <emptyTip />
      </template>
    </div>
  </div>
</template>

<script>
import emptyTip from "./empty.vue";
import Vchart from "@c/Vchart.vue";
export default {
  props: {
    piedata: {
      type: Array,
      default: () => ([])
    },
    title:{
      type: String,
      default: () => ("")
    },
  },
  data() {
    return {
    }
  },
  computed: {


            
    echartData() {
      let option ={
        color: ['#4DDE6D', '#FFD74D', '#01C1B2', '#FF6A00', '#18B1F7'],
        tooltip: {
          trigger: 'item',
          formatter:'{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          top: '5%',
          left: 'center'
        },
        series: [
          {
            name: this.title,
            type: 'pie',
            radius: '50%',
            data:this.piedata,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      return option;
    }
  },
  components: {
    Vchart,
    emptyTip
  }
};
</script>

<style>
.pie-box {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pie-flx {
  width: 458px !important;
  height: 100%;
  /* position: absolute;
  left: 50%;
  margin-left: -287px; */
}
</style>
